import { render, staticRenderFns } from "./ai-qa-edit.vue?vue&type=template&id=2ab0b3ea&scoped=true"
import script from "./ai-qa-edit.vue?vue&type=script&lang=ts"
export * from "./ai-qa-edit.vue?vue&type=script&lang=ts"
import style0 from "./ai-qa-edit.vue?vue&type=style&index=0&id=2ab0b3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0b3ea",
  null
  
)

export default component.exports